{
  "lastUpdatedAt": "2026-09-14T13:54:01.152Z",
  "lastFetchAttemptAt": "2026-09-14T13:54:01.152Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}